import * as React from 'react';

import * as styles from './MortgageBanner.css';

interface IMortgageBannerProps {
  innerHTML: string;
}

/* istanbul ignore next */
export const MortgageBanner: React.FC<IMortgageBannerProps> = ({ innerHTML }) => {
  // eslint-disable-next-line react/no-danger
  return <div className={styles['container']} dangerouslySetInnerHTML={{ __html: innerHTML }} />;
};
